import type { Dispatch, SetStateAction } from "react";
import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { EditorOverlay } from "../components/SlateEditor/LinkManagePopup";

interface IProps {
  children: React.ReactNode;
  editor: any;
  inPopup: boolean;
}

interface ITooltipContextProps {
  value: any;
  setCurrentTarget: Dispatch<SetStateAction<any>>;
  setUrl: Dispatch<SetStateAction<string>>;
  url: string;
}

const initPopupsState = {
  value: null,
  setCurrentTarget: () => {},
  setUrl: () => {},
  url: "",
};

interface ICurrentTarget {
  element: any;
  type: "prepareLink" | "readyLink";
}

export const EditorPopupContext =
  createContext<ITooltipContextProps>(initPopupsState);

export const useEditorPopupContext = () => useContext(EditorPopupContext);

export const EditorPopupProvider: React.FC<IProps> = ({
  children,
  editor,
  inPopup,
}) => {
  const [currentTarget, setCurrentTarget] = useState<ICurrentTarget | null>(
    null,
  );
  const [url, setUrl] = useState("");

  const closePopup = useCallback(() => {
    setCurrentTarget(null);
  }, []);

  const setAsPrepareLink = useCallback(() => {
    currentTarget &&
      setCurrentTarget({
        element: currentTarget.element,
        type: "prepareLink",
      });
  }, [currentTarget]);

  const contextValue = useMemo(() => {
    return {
      setCurrentTarget,
      setUrl,
      url,
      value: null,
    };
  }, [setCurrentTarget, setUrl, url]);

  return (
    <EditorPopupContext.Provider value={contextValue}>
      {children}
      {currentTarget && (
        <EditorOverlay
          editor={editor}
          currentTarget={currentTarget}
          closePopup={closePopup}
          setAsPrepareLink={setAsPrepareLink}
          inPopup={inPopup}
        />
      )}
    </EditorPopupContext.Provider>
  );
};
